import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AWSTimestamp: any;
};

export type Account = {
  __typename?: 'Account';
  createdAt: Scalars['AWSTimestamp'];
  ethAddress: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  fundsOrigin?: Maybe<FundsOrigin>;
  idStatus?: Maybe<IdStatus>;
  idStatusCode?: Maybe<Scalars['Int']>;
  idStatusMessage?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  notPEP?: Maybe<Scalars['Boolean']>;
  occupation?: Maybe<Scalars['String']>;
  status: AccountStatus;
  updatedAt?: Maybe<Scalars['AWSTimestamp']>;
};

export type AccountInput = {
  createdAt: Scalars['AWSTimestamp'];
  ethAddress: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  fundsOrigin?: InputMaybe<FundsOrigin>;
  idStatus?: InputMaybe<IdStatus>;
  idStatusCode?: InputMaybe<Scalars['Int']>;
  idStatusMessage?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  notPEP?: InputMaybe<Scalars['Boolean']>;
  occupation?: InputMaybe<Scalars['String']>;
  status: AccountStatus;
  updatedAt?: InputMaybe<Scalars['AWSTimestamp']>;
};

export enum AccountStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  VERIFIED = 'verified'
}

export type Balance = {
  __typename?: 'Balance';
  ethAddress: Scalars['String'];
};

export enum FundsOrigin {
  FREELANCE = 'freelance',
  SALARY = 'salary'
}

export type IdSession = {
  __typename?: 'IdSession';
  idSessionUrl: Scalars['String'];
};

export enum IdStatus {
  ABANDONED = 'abandoned',
  APPROVED = 'approved',
  DECLINED = 'declined',
  EXPIRED = 'expired',
  RESUBMISSION_REQUESTED = 'resubmission_requested',
  SUBMITTED = 'submitted'
}

export type Mutation = {
  __typename?: 'Mutation';
  createIdSession: IdSession;
  createPayout: Payout;
  createRecharge: Redirect;
  publishAccountUpdated: Account;
  publishBalanceUpdated: Balance;
  publishTransactionCreated: Transaction;
  publishTransactionUpdated: Transaction;
  sendTransaction: Transaction;
  updateAccount: Account;
};


export type MutationCreatePayoutArgs = {
  amount: Scalars['Int'];
};


export type MutationCreateRechargeArgs = {
  amount: Scalars['Int'];
};


export type MutationPublishAccountUpdatedArgs = {
  input: AccountInput;
};


export type MutationPublishBalanceUpdatedArgs = {
  ethAddress: Scalars['String'];
};


export type MutationPublishTransactionCreatedArgs = {
  input: TransactionInput;
};


export type MutationPublishTransactionUpdatedArgs = {
  input: TransactionInput;
};


export type MutationSendTransactionArgs = {
  input: SendTransactionInput;
};


export type MutationUpdateAccountArgs = {
  input: UpdateAccountInput;
};

export type Payout = {
  __typename?: 'Payout';
  amount: Scalars['Int'];
  createdAt: Scalars['AWSTimestamp'];
  ethAddress: Scalars['String'];
  id: Scalars['ID'];
  status: PayoutStatus;
  updatedAt?: Maybe<Scalars['AWSTimestamp']>;
};

export enum PayoutStatus {
  AUTHORIZED = 'authorized',
  CONFIRMED = 'confirmed',
  FAILED = 'failed',
  PENDING = 'pending'
}

export type Query = {
  __typename?: 'Query';
  account?: Maybe<Account>;
  balance: Scalars['Int'];
  transaction?: Maybe<Transaction>;
  transactions: TransactionConnection;
};


export type QueryTransactionArgs = {
  id: Scalars['ID'];
};


export type QueryTransactionsArgs = {
  filter?: InputMaybe<TransactionFilterInput>;
  from?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
};

export type Redirect = {
  __typename?: 'Redirect';
  mustRedirect: Scalars['Boolean'];
  redirectUrl: Scalars['String'];
};

export type SearchableBooleanFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
};

export type SearchableFloatFilterInput = {
  eq?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type SearchableIdFilterInput = {
  eq?: InputMaybe<Scalars['ID']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  match?: InputMaybe<Scalars['ID']>;
  matchPhrase?: InputMaybe<Scalars['ID']>;
  matchPhrasePrefix?: InputMaybe<Scalars['ID']>;
  ne?: InputMaybe<Scalars['ID']>;
  regexp?: InputMaybe<Scalars['ID']>;
  wildcard?: InputMaybe<Scalars['ID']>;
};

export type SearchableIntFilterInput = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  ne?: InputMaybe<Scalars['Int']>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type SearchableStringFilterInput = {
  eq?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  match?: InputMaybe<Scalars['String']>;
  matchPhrase?: InputMaybe<Scalars['String']>;
  matchPhrasePrefix?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  regexp?: InputMaybe<Scalars['String']>;
  wildcard?: InputMaybe<Scalars['String']>;
};

export type SendTransactionInput = {
  amount: Scalars['Int'];
  ethAddress?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  onAccountUpdated?: Maybe<Account>;
  onBalanceUpdated?: Maybe<Balance>;
  onTransactionCreated?: Maybe<Transaction>;
  onTransactionUpdated?: Maybe<Transaction>;
};


export type SubscriptionOnTransactionUpdatedArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type Transaction = {
  __typename?: 'Transaction';
  amount: Scalars['Int'];
  confirmedAt?: Maybe<Scalars['AWSTimestamp']>;
  createdAt: Scalars['AWSTimestamp'];
  fromAddress: Scalars['String'];
  fromPhoneNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  replacementId?: Maybe<Scalars['ID']>;
  status: TransactionStatus;
  toAddress: Scalars['String'];
  toPhoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']>;
};

export type TransactionConnection = {
  __typename?: 'TransactionConnection';
  items: Array<Transaction>;
  total?: Maybe<Scalars['Int']>;
};

export type TransactionFilterInput = {
  amount?: InputMaybe<SearchableIntFilterInput>;
  and?: InputMaybe<Array<InputMaybe<TransactionFilterInput>>>;
  createdAt?: InputMaybe<SearchableStringFilterInput>;
  fromAddress?: InputMaybe<SearchableStringFilterInput>;
  fromPhoneNumber?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  message?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<TransactionFilterInput>;
  or?: InputMaybe<Array<InputMaybe<TransactionFilterInput>>>;
  status?: InputMaybe<SearchableStringFilterInput>;
  toAddress?: InputMaybe<SearchableStringFilterInput>;
  toPhoneNumber?: InputMaybe<SearchableStringFilterInput>;
  updatedAt?: InputMaybe<SearchableStringFilterInput>;
};

export type TransactionInput = {
  amount: Scalars['Int'];
  confirmedAt?: InputMaybe<Scalars['AWSTimestamp']>;
  createdAt: Scalars['AWSTimestamp'];
  fromAddress: Scalars['String'];
  fromPhoneNumber?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
  replacementId?: InputMaybe<Scalars['ID']>;
  status: TransactionStatus;
  toAddress: Scalars['String'];
  toPhoneNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['AWSTimestamp']>;
};

export enum TransactionStatus {
  AUTHORIZED = 'authorized',
  CONFIRMED = 'confirmed',
  FAILED = 'failed'
}

export type UpdateAccountInput = {
  fundsOrigin?: InputMaybe<FundsOrigin>;
  notPEP?: InputMaybe<Scalars['Boolean']>;
  occupation?: InputMaybe<Scalars['String']>;
};

export type TransactionFieldsFragment = { __typename?: 'Transaction', id: string, replacementId?: string | null | undefined, status: TransactionStatus, amount: number, fromAddress: string, toAddress: string, fromPhoneNumber?: string | null | undefined, toPhoneNumber?: string | null | undefined, message?: string | null | undefined, createdAt: any, updatedAt?: any | null | undefined };

export type AccountFieldsFragment = { __typename?: 'Account', ethAddress: string, status: AccountStatus, idStatus?: IdStatus | null | undefined, idStatusMessage?: string | null | undefined, idStatusCode?: number | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, fundsOrigin?: FundsOrigin | null | undefined, notPEP?: boolean | null | undefined, occupation?: string | null | undefined, createdAt: any, updatedAt?: any | null | undefined };

export type SendTransactionMutationVariables = Exact<{
  input: SendTransactionInput;
}>;


export type SendTransactionMutation = { __typename?: 'Mutation', sendTransaction: { __typename?: 'Transaction', id: string, replacementId?: string | null | undefined, status: TransactionStatus, amount: number, fromAddress: string, toAddress: string, fromPhoneNumber?: string | null | undefined, toPhoneNumber?: string | null | undefined, message?: string | null | undefined, createdAt: any, updatedAt?: any | null | undefined } };

export type CreateRechargeMutationVariables = Exact<{
  amount: Scalars['Int'];
}>;


export type CreateRechargeMutation = { __typename?: 'Mutation', createRecharge: { __typename?: 'Redirect', redirectUrl: string, mustRedirect: boolean } };

export type CreateIdSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateIdSessionMutation = { __typename?: 'Mutation', createIdSession: { __typename?: 'IdSession', idSessionUrl: string } };

export type UpdateAccountMutationVariables = Exact<{
  input: UpdateAccountInput;
}>;


export type UpdateAccountMutation = { __typename?: 'Mutation', updateAccount: { __typename?: 'Account', ethAddress: string, status: AccountStatus, idStatus?: IdStatus | null | undefined, idStatusMessage?: string | null | undefined, idStatusCode?: number | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, fundsOrigin?: FundsOrigin | null | undefined, notPEP?: boolean | null | undefined, occupation?: string | null | undefined, createdAt: any, updatedAt?: any | null | undefined } };

export type CreatePayoutMutationVariables = Exact<{
  amount: Scalars['Int'];
}>;


export type CreatePayoutMutation = { __typename?: 'Mutation', createPayout: { __typename?: 'Payout', id: string, amount: number, ethAddress: string, status: PayoutStatus, createdAt: any, updatedAt?: any | null | undefined } };

export type BalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type BalanceQuery = { __typename?: 'Query', balance: number };

export type TransactionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TransactionQuery = { __typename?: 'Query', transaction?: { __typename?: 'Transaction', id: string, replacementId?: string | null | undefined, status: TransactionStatus, amount: number, fromAddress: string, toAddress: string, fromPhoneNumber?: string | null | undefined, toPhoneNumber?: string | null | undefined, message?: string | null | undefined, createdAt: any, updatedAt?: any | null | undefined } | null | undefined };

export type TransactionsQueryVariables = Exact<{
  filter?: InputMaybe<TransactionFilterInput>;
  size?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['Int']>;
}>;


export type TransactionsQuery = { __typename?: 'Query', transactions: { __typename?: 'TransactionConnection', total?: number | null | undefined, items: Array<{ __typename?: 'Transaction', id: string, replacementId?: string | null | undefined, status: TransactionStatus, amount: number, fromAddress: string, toAddress: string, fromPhoneNumber?: string | null | undefined, toPhoneNumber?: string | null | undefined, message?: string | null | undefined, createdAt: any, updatedAt?: any | null | undefined }> } };

export type AccountQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountQuery = { __typename?: 'Query', account?: { __typename?: 'Account', ethAddress: string, status: AccountStatus, idStatus?: IdStatus | null | undefined, idStatusMessage?: string | null | undefined, idStatusCode?: number | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, fundsOrigin?: FundsOrigin | null | undefined, notPEP?: boolean | null | undefined, occupation?: string | null | undefined, createdAt: any, updatedAt?: any | null | undefined } | null | undefined };

export type OnTransactionCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnTransactionCreatedSubscription = { __typename?: 'Subscription', onTransactionCreated?: { __typename?: 'Transaction', id: string, replacementId?: string | null | undefined, status: TransactionStatus, amount: number, fromAddress: string, toAddress: string, fromPhoneNumber?: string | null | undefined, toPhoneNumber?: string | null | undefined, message?: string | null | undefined, createdAt: any, updatedAt?: any | null | undefined } | null | undefined };

export type OnTransactionUpdatedSubscriptionVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type OnTransactionUpdatedSubscription = { __typename?: 'Subscription', onTransactionUpdated?: { __typename?: 'Transaction', id: string, replacementId?: string | null | undefined, status: TransactionStatus, amount: number, fromAddress: string, toAddress: string, fromPhoneNumber?: string | null | undefined, toPhoneNumber?: string | null | undefined, message?: string | null | undefined, createdAt: any, updatedAt?: any | null | undefined } | null | undefined };

export type OnBalanceUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnBalanceUpdatedSubscription = { __typename?: 'Subscription', onBalanceUpdated?: { __typename?: 'Balance', ethAddress: string } | null | undefined };

export type OnAccountUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnAccountUpdatedSubscription = { __typename?: 'Subscription', onAccountUpdated?: { __typename?: 'Account', ethAddress: string, status: AccountStatus, idStatus?: IdStatus | null | undefined, idStatusMessage?: string | null | undefined, idStatusCode?: number | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, fundsOrigin?: FundsOrigin | null | undefined, notPEP?: boolean | null | undefined, occupation?: string | null | undefined, createdAt: any, updatedAt?: any | null | undefined } | null | undefined };

export const TransactionFieldsFragmentDoc = gql`
    fragment TransactionFields on Transaction {
  id
  replacementId
  status
  amount
  fromAddress
  toAddress
  fromPhoneNumber
  toPhoneNumber
  message
  createdAt
  updatedAt
}
    `;
export const AccountFieldsFragmentDoc = gql`
    fragment AccountFields on Account {
  ethAddress
  status
  idStatus
  idStatusMessage
  idStatusCode
  firstName
  lastName
  fundsOrigin
  notPEP
  occupation
  createdAt
  updatedAt
}
    `;
export const SendTransactionDocument = gql`
    mutation SendTransaction($input: SendTransactionInput!) {
  sendTransaction(input: $input) {
    ...TransactionFields
  }
}
    ${TransactionFieldsFragmentDoc}`;

/**
 * __useSendTransactionMutation__
 *
 * To run a mutation, you first call `useSendTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTransactionMutation, { data, loading, error }] = useSendTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendTransactionMutation(baseOptions?: Apollo.MutationHookOptions<SendTransactionMutation, SendTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTransactionMutation, SendTransactionMutationVariables>(SendTransactionDocument, options);
      }
export type SendTransactionMutationHookResult = ReturnType<typeof useSendTransactionMutation>;
export type SendTransactionMutationResult = Apollo.MutationResult<SendTransactionMutation>;
export type SendTransactionMutationOptions = Apollo.BaseMutationOptions<SendTransactionMutation, SendTransactionMutationVariables>;
export const CreateRechargeDocument = gql`
    mutation CreateRecharge($amount: Int!) {
  createRecharge(amount: $amount) {
    redirectUrl
    mustRedirect
  }
}
    `;

/**
 * __useCreateRechargeMutation__
 *
 * To run a mutation, you first call `useCreateRechargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRechargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRechargeMutation, { data, loading, error }] = useCreateRechargeMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useCreateRechargeMutation(baseOptions?: Apollo.MutationHookOptions<CreateRechargeMutation, CreateRechargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRechargeMutation, CreateRechargeMutationVariables>(CreateRechargeDocument, options);
      }
export type CreateRechargeMutationHookResult = ReturnType<typeof useCreateRechargeMutation>;
export type CreateRechargeMutationResult = Apollo.MutationResult<CreateRechargeMutation>;
export type CreateRechargeMutationOptions = Apollo.BaseMutationOptions<CreateRechargeMutation, CreateRechargeMutationVariables>;
export const CreateIdSessionDocument = gql`
    mutation CreateIdSession {
  createIdSession {
    idSessionUrl
  }
}
    `;

/**
 * __useCreateIdSessionMutation__
 *
 * To run a mutation, you first call `useCreateIdSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIdSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIdSessionMutation, { data, loading, error }] = useCreateIdSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateIdSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateIdSessionMutation, CreateIdSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIdSessionMutation, CreateIdSessionMutationVariables>(CreateIdSessionDocument, options);
      }
export type CreateIdSessionMutationHookResult = ReturnType<typeof useCreateIdSessionMutation>;
export type CreateIdSessionMutationResult = Apollo.MutationResult<CreateIdSessionMutation>;
export type CreateIdSessionMutationOptions = Apollo.BaseMutationOptions<CreateIdSessionMutation, CreateIdSessionMutationVariables>;
export const UpdateAccountDocument = gql`
    mutation UpdateAccount($input: UpdateAccountInput!) {
  updateAccount(input: $input) {
    ...AccountFields
  }
}
    ${AccountFieldsFragmentDoc}`;

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMutation, { data, loading, error }] = useUpdateAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountMutation, UpdateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(UpdateAccountDocument, options);
      }
export type UpdateAccountMutationHookResult = ReturnType<typeof useUpdateAccountMutation>;
export type UpdateAccountMutationResult = Apollo.MutationResult<UpdateAccountMutation>;
export type UpdateAccountMutationOptions = Apollo.BaseMutationOptions<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const CreatePayoutDocument = gql`
    mutation CreatePayout($amount: Int!) {
  createPayout(amount: $amount) {
    id
    amount
    ethAddress
    status
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useCreatePayoutMutation__
 *
 * To run a mutation, you first call `useCreatePayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPayoutMutation, { data, loading, error }] = useCreatePayoutMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useCreatePayoutMutation(baseOptions?: Apollo.MutationHookOptions<CreatePayoutMutation, CreatePayoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePayoutMutation, CreatePayoutMutationVariables>(CreatePayoutDocument, options);
      }
export type CreatePayoutMutationHookResult = ReturnType<typeof useCreatePayoutMutation>;
export type CreatePayoutMutationResult = Apollo.MutationResult<CreatePayoutMutation>;
export type CreatePayoutMutationOptions = Apollo.BaseMutationOptions<CreatePayoutMutation, CreatePayoutMutationVariables>;
export const BalanceDocument = gql`
    query Balance {
  balance
}
    `;

/**
 * __useBalanceQuery__
 *
 * To run a query within a React component, call `useBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBalanceQuery({
 *   variables: {
 *   },
 * });
 */
export function useBalanceQuery(baseOptions?: Apollo.QueryHookOptions<BalanceQuery, BalanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BalanceQuery, BalanceQueryVariables>(BalanceDocument, options);
      }
export function useBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BalanceQuery, BalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BalanceQuery, BalanceQueryVariables>(BalanceDocument, options);
        }
export type BalanceQueryHookResult = ReturnType<typeof useBalanceQuery>;
export type BalanceLazyQueryHookResult = ReturnType<typeof useBalanceLazyQuery>;
export type BalanceQueryResult = Apollo.QueryResult<BalanceQuery, BalanceQueryVariables>;
export const TransactionDocument = gql`
    query Transaction($id: ID!) {
  transaction(id: $id) {
    ...TransactionFields
  }
}
    ${TransactionFieldsFragmentDoc}`;

/**
 * __useTransactionQuery__
 *
 * To run a query within a React component, call `useTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTransactionQuery(baseOptions: Apollo.QueryHookOptions<TransactionQuery, TransactionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionQuery, TransactionQueryVariables>(TransactionDocument, options);
      }
export function useTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionQuery, TransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionQuery, TransactionQueryVariables>(TransactionDocument, options);
        }
export type TransactionQueryHookResult = ReturnType<typeof useTransactionQuery>;
export type TransactionLazyQueryHookResult = ReturnType<typeof useTransactionLazyQuery>;
export type TransactionQueryResult = Apollo.QueryResult<TransactionQuery, TransactionQueryVariables>;
export const TransactionsDocument = gql`
    query Transactions($filter: TransactionFilterInput, $size: Int, $from: Int) {
  transactions(filter: $filter, size: $size, from: $from) {
    items {
      ...TransactionFields
    }
    total
  }
}
    ${TransactionFieldsFragmentDoc}`;

/**
 * __useTransactionsQuery__
 *
 * To run a query within a React component, call `useTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      size: // value for 'size'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<TransactionsQuery, TransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionsQuery, TransactionsQueryVariables>(TransactionsDocument, options);
      }
export function useTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionsQuery, TransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionsQuery, TransactionsQueryVariables>(TransactionsDocument, options);
        }
export type TransactionsQueryHookResult = ReturnType<typeof useTransactionsQuery>;
export type TransactionsLazyQueryHookResult = ReturnType<typeof useTransactionsLazyQuery>;
export type TransactionsQueryResult = Apollo.QueryResult<TransactionsQuery, TransactionsQueryVariables>;
export const AccountDocument = gql`
    query Account {
  account {
    ...AccountFields
  }
}
    ${AccountFieldsFragmentDoc}`;

/**
 * __useAccountQuery__
 *
 * To run a query within a React component, call `useAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountQuery(baseOptions?: Apollo.QueryHookOptions<AccountQuery, AccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountQuery, AccountQueryVariables>(AccountDocument, options);
      }
export function useAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountQuery, AccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountQuery, AccountQueryVariables>(AccountDocument, options);
        }
export type AccountQueryHookResult = ReturnType<typeof useAccountQuery>;
export type AccountLazyQueryHookResult = ReturnType<typeof useAccountLazyQuery>;
export type AccountQueryResult = Apollo.QueryResult<AccountQuery, AccountQueryVariables>;
export const OnTransactionCreatedDocument = gql`
    subscription OnTransactionCreated {
  onTransactionCreated {
    ...TransactionFields
  }
}
    ${TransactionFieldsFragmentDoc}`;

/**
 * __useOnTransactionCreatedSubscription__
 *
 * To run a query within a React component, call `useOnTransactionCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnTransactionCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnTransactionCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnTransactionCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnTransactionCreatedSubscription, OnTransactionCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnTransactionCreatedSubscription, OnTransactionCreatedSubscriptionVariables>(OnTransactionCreatedDocument, options);
      }
export type OnTransactionCreatedSubscriptionHookResult = ReturnType<typeof useOnTransactionCreatedSubscription>;
export type OnTransactionCreatedSubscriptionResult = Apollo.SubscriptionResult<OnTransactionCreatedSubscription>;
export const OnTransactionUpdatedDocument = gql`
    subscription OnTransactionUpdated($id: ID) {
  onTransactionUpdated(id: $id) {
    ...TransactionFields
  }
}
    ${TransactionFieldsFragmentDoc}`;

/**
 * __useOnTransactionUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnTransactionUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnTransactionUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnTransactionUpdatedSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOnTransactionUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnTransactionUpdatedSubscription, OnTransactionUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnTransactionUpdatedSubscription, OnTransactionUpdatedSubscriptionVariables>(OnTransactionUpdatedDocument, options);
      }
export type OnTransactionUpdatedSubscriptionHookResult = ReturnType<typeof useOnTransactionUpdatedSubscription>;
export type OnTransactionUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnTransactionUpdatedSubscription>;
export const OnBalanceUpdatedDocument = gql`
    subscription OnBalanceUpdated {
  onBalanceUpdated {
    ethAddress
  }
}
    `;

/**
 * __useOnBalanceUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnBalanceUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnBalanceUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnBalanceUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnBalanceUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnBalanceUpdatedSubscription, OnBalanceUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnBalanceUpdatedSubscription, OnBalanceUpdatedSubscriptionVariables>(OnBalanceUpdatedDocument, options);
      }
export type OnBalanceUpdatedSubscriptionHookResult = ReturnType<typeof useOnBalanceUpdatedSubscription>;
export type OnBalanceUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnBalanceUpdatedSubscription>;
export const OnAccountUpdatedDocument = gql`
    subscription OnAccountUpdated {
  onAccountUpdated {
    ...AccountFields
  }
}
    ${AccountFieldsFragmentDoc}`;

/**
 * __useOnAccountUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnAccountUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAccountUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAccountUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnAccountUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnAccountUpdatedSubscription, OnAccountUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnAccountUpdatedSubscription, OnAccountUpdatedSubscriptionVariables>(OnAccountUpdatedDocument, options);
      }
export type OnAccountUpdatedSubscriptionHookResult = ReturnType<typeof useOnAccountUpdatedSubscription>;
export type OnAccountUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnAccountUpdatedSubscription>;